import * as React from 'react'

import apis from '@app/api/api'

import ScreenContainer from '@components/screenContainer/screenContainer'
import BusinessDetailsMenu from '@components/menu/businessDetailsMenu'
import BusinessDetailsContent from '@components/content/businessDetailsContent'

interface Props {
  navigation: Navigation
  businessId: string
}

const BusinessDetails = ({ navigation, businessId }: Props) => {
  const [screenStatus, setScreenStatus] = React.useState<ScreenStatus>('loading')
  const [actualTab, setActualTab] = React.useState<Tab>('state')

  const [steps, setSteps] = React.useState<BusinessStep[]>([])
  const [business, setBusiness] = React.useState<AllBusinessDetails | undefined>(undefined)
  const [declarations, setDeclarations] = React.useState<BusinessDeclaration[]>([])
  const [sectionPictures, setSectionPictures] = React.useState<BusinessDetailsPicture[]>([])

  React.useEffect(() => {
    Promise.all([apis.business.details(businessId), apis.business.get(businessId), apis.step.list()])
      .then(([b, d, s]) => {
        setSteps(s)
        setBusiness(b)
        setDeclarations(d.declarations)
        setSectionPictures(b.pictures)
        setScreenStatus('fetched')
      })
      .catch(() => setScreenStatus('error'))
  }, [])

  const commentBusiness = (b: AllBusinessDetails, c: BusinessDetailsComment) =>
    setBusiness({
      ...b,
      comments: [...b.comments, c],
    })

  return (
    <ScreenContainer
      menu={
        <BusinessDetailsMenu
          navigation={navigation}
          screenStatus={screenStatus}
          business={business}
          setBusiness={setBusiness}
          declarations={declarations}
          actualTab={actualTab}
          setActualTab={setActualTab}
          //FiltersProps
          steps={steps}
          setSectionPictures={setSectionPictures}
          allPictures={business ? business.pictures : []}
        />
      }
      content={
        <BusinessDetailsContent
          steps={steps}
          business={business}
          declarations={declarations}
          actualTab={actualTab}
          navigation={navigation}
          screenStatus={screenStatus}
          commentBusiness={(c: BusinessDetailsComment) => business && commentBusiness(business, c)}
          sectionPictures={sectionPictures}
          setSectionPictures={setSectionPictures}
        />
      }
    />
  )
}

export default BusinessDetails
